import { http } from 'app/lib/axios';
import type { NewListingSource } from 'app/types/listing';

export interface SuggestedListing {
  id: string;
  isPriority?: boolean;
  listingGroup: {
    name: string | null;
    picture: string | null;
  };
}

export type SuggestedListingAnswer = 'yes' | 'no';

export async function getSuggestedListings(): Promise<SuggestedListing[]> {
  return (await http.get<SuggestedListing[]>('/listings/suggested')).data;
}

export async function answerSuggestedListing(
  id: SuggestedListing['id'],
  answer: SuggestedListingAnswer,
  source: NewListingSource | undefined,
  signal: AbortSignal,
): Promise<void> {
  await http.post(`/listings/suggested/${id}/${answer}`, undefined, {
    signal,
    ...(source ? { params: { source } } : {}),
  });
}
